import { useState, useEffect } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cachedCity = null;

export function useVisitorCity(fallback = 'your city') {
  const [city, setCity] = useState(cachedCity || fallback);

  useEffect(() => {
    if (cachedCity) {
      setCity(cachedCity);
      return;
    }

    fetch(`${API}/geo/city`)
      .then(res => res.json())
      .then(data => {
        if (data?.city) {
          cachedCity = data.city;
          setCity(data.city);
        }
      })
      .catch(() => {});
  }, []);

  return city;
}
